// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"344":"6874762e","375":"82aa5af1"}[chunkId] + ".chunk.css";
};